/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseGlobalConfigFragment} from '@amblique/contentful/app/contentful/fragments/global-config/base-global-config.fragment';
import {BaseHeroBannerFragment} from '@amblique/contentful/app/contentful/fragments/hero-banner/base-hero-banner.fragment';
import {BaseIconFragment} from '@amblique/contentful/app/contentful/fragments/icon/base-icon.fragment';
import {BaseImageFragment} from '@amblique/contentful/app/contentful/fragments/image/base-image.fragment';
import {BaseLinkFragment} from '@amblique/contentful/app/contentful/fragments/link/base-link.fragment';

export const GlobalConfigFragment = gql`
  ${BaseGlobalConfigFragment}
  ${BaseHeroBannerFragment}
  ${BaseIconFragment}
  ${BaseImageFragment}
  ${BaseLinkFragment}

  fragment GlobalConfigFragment on GlobalConfig {
    ...BaseGlobalConfigFragment

    accountHero {
      ...BaseHeroBannerFragment
    }
    cartPaymentIconsCollection {
      items {
        __typename
        ... on Icon {
          ...BaseIconFragment
        }
      }
    }
    countriesCollection {
      items {
        __typename
        ... on Link {
          ...BaseLinkFragment
        }
      }
    }
    showroomFooter {
      ...BaseHeroBannerFragment
    }
    showroomHero {
      ...BaseHeroBannerFragment
    }
    signUpImage {
      ...BaseImageFragment
    }
    socialLinksCollection {
      items {
        __typename
        ... on Link {
          ...BaseLinkFragment
        }
      }
    }
  }
`;
